<div class="flex flex-col border rounded-md border-neutral-100 h-full">
  <div class="flex gap-1 items-center bg-neutral-50 p-2 rounded-t-md border-b border-neutral-100">
    <flx-select
      [formControl]="viewModeFC"
      class="flx-ds small"
      data-testid="ui-flow-session-variables-view-mode-select"
      overlayClass="ui-flow-session-variables-overlay"
    >
      @for (option of viewVariablesOptions; track option.value) {
        <flx-select-option
          [value]="option"
          [attr.data-testid]="'ui-flow-session-variables-view-mode-' + option.value"
        >
          {{ option.label }}
        </flx-select-option>
      }
    </flx-select>
    <button
      (click)="exportVariables()"
      class="flx-ds secondary small"
      flxButton
      data-testid="export-ui-flow-session-variables"
      type="button"
      variant="text"
    >
      Export JSON
    </button>
  </div>

  <div
    [class.overflow-auto]="viewModeValue() === 'tree'"
    class="p-2 h-full"
  >
    @if (sessionVariables()) {
      @switch (viewModeValue()) {
        @case ('tree') {
          <flx-json-viewer
            [json]="sessionVariables()"
            [expanded]="false"
            class="block overflow-y-auto"
          />
        }
        @case ('json') {
          <flx-code-editor
            [ngModel]="stringifiedVariables()"
            [options]="defaultJsonEditorOptions"
            [readonly]="true"
            class="w-full h-full grow"
            data-testid="ui-flow-session-variables-json-editor"
          />
        }
      }
    } @else {
      <flx-empty-infobox
        class="h-full"
        message="No variables"
        description="The data of this session appears here as it is set."
      />
    }
  </div>
</div>
